import AppointmentIndexPage from "./AppointmentIndexPage";
export default AppointmentIndexPage;
